var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { LogLevel, LogStatus, LogType } from 'public-contracts';
import { singleton } from '../../decorators';
import { QueueService } from '../../services/Queue.service';
import { Injector } from '../../services/Injector';
let LogService = class LogService {
    api;
    getAuthHeader;
    queueService = Injector.inject('queueService', QueueService);
    queueId = this.queueService.createQueue();
    delay = 5000;
    baseLogItem = {
        message: '',
        level: LogLevel.INFO,
        context: '',
        metadata: '',
        stack: '',
        status: LogStatus.PENDING,
        type: LogType.INFO,
    };
    constructor(api, getAuthHeader) {
        this.api = api;
        this.getAuthHeader = getAuthHeader;
    }
    async sendLog(logs) {
        const res = await fetch(this.api + '/log', {
            headers: {
                ...(await this.getAuthHeader()),
                'Content-Type': 'application/json',
            },
            method: 'POST',
            body: JSON.stringify(logs),
        });
        return res.json();
    }
    async getLogs() {
        const res = await fetch(this.api + '/log', {
            headers: {
                ...(await this.getAuthHeader()),
                'Content-Type': 'application/json',
            },
            method: 'GET',
        });
        return res.json();
    }
    async log(log) {
        // TEMP FIX: Completely disable logging to prevent queue/context errors
        console.log('[LogService] Logging disabled, skipping:', log.message);
        return;
        // Original code disabled:
        // this.queueService.enqueue(this.queueId, log);
        // setTimeout(() => {
        //   const logs = this.queueService.dispose(this.queueId);
        //   this.sendLog(logs);
        // }, this.delay);
    }
    setDelay(delay) {
        this.delay = delay;
    }
    info(message, metadata) {
        this.log({ ...this.baseLogItem, message, metadata, level: LogLevel.INFO });
    }
    warn(message, metadata) {
        this.log({ ...this.baseLogItem, message, metadata, level: LogLevel.WARN });
    }
    error(message, stack, metadata) {
        this.log({
            ...this.baseLogItem,
            message,
            metadata,
            level: LogLevel.ERROR,
            stack,
        });
    }
    debug(message, metadata) {
        this.log({ ...this.baseLogItem, message, metadata, level: LogLevel.DEBUG });
    }
    trace(message, stack, metadata) {
        this.log({
            ...this.baseLogItem,
            message,
            metadata,
            level: LogLevel.TRACE,
            stack,
        });
    }
};
LogService = __decorate([
    singleton,
    __metadata("design:paramtypes", [String, Function])
], LogService);
export { LogService };
//# sourceMappingURL=data:application/json;base64,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